// mode used to browse user's directories
export const DIRECTORY_PERMISSION_MODE = 'read'

// list of extensions for book files supported by the application. It always includes directories
export const BOOK_EXTENSIONS_SUPPORTED = ['.pdf', '.zip', '.cbz']

// list of extensions for page files supported by the application
export const PAGE_EXTENSIONS_SUPPORTED = ['.jpg', '.jpeg', '.png', '.bmp', '.tiff']

// key used for persistence
export const PERSISTENCE_KEY = 'keiwen-dans-ma-bulle'

export const BOOK_TYPE_IMAGE_FOLDER = 'image_folder'
export const BOOK_TYPE_PDF = 'pdf'
export const BOOK_TYPE_ZIP = 'zip'
